// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs-LjYBE","separator":"separator-iOyV2","active":"active-DT2ad"};